import styled from "styled-components";
import Switch from "rc-switch";

export const ToggleWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Toggle = styled(Switch)`
  background-color: ${({ isNewDataVisualization }) =>
    isNewDataVisualization ? "#3f51b5" : "#ccc"};
  border-color: ${({ isNewDataVisualization }) => (isNewDataVisualization ? "#3f51b5" : "#ccc")};
`;
